import* as Vue from 'vue';
// import { createApp } from 'vue/dist/vue.runtime.esm-bundler'
import { createApp } from 'vue/dist/vue.esm-bundler';
import { createStore } from 'vuex' 
import recipeHelpers from "./helper.js";
import App from './App.vue'
require('@/assets/css/icons.min.css')  
require('@/assets/css/app.min.css')   
require('@/assets/css/style.css')   
 
import router from './router' 
import store   from './store';  
import { mapGetters, mapActions } from "vuex";
import jQuery from 'jquery'
// start for menu icon 
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas); 
import { dom } from "@fortawesome/fontawesome-svg-core";
dom.watch(); 
// End for menu icon 


require("unicons");
  
import notification from '@kyvg/vue3-notification';
import Vue3Transitions from 'vue3-transitions'
import "bootstrap/dist/js/bootstrap.min.js";
import Toaster from '@meforma/vue-toaster';


import Toast, { PluginOptions } from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css'; 
 
 
import Vue3TreeSelect from "vue3-treeselect";
// import the styles
import 'vue3-treeselect/dist/vue3-treeselect.css';

import Autocomplete from "vue3-autocomplete";
import 'vue3-autocomplete/dist/vue3-autocomplete.css';

import VueBarcode from '@chenfengyuan/vue-barcode';

// For ApexChart
import VueApexCharts from "vue3-apexcharts";
import moment from 'moment'

//import JlDatatable from 'jl-datatable'

import  VueHtmlToPaper from './plugins/VueHtmlToPaper'
 
window.Fire = createApp(App); 
const app = createApp(App); 
import VueformMultiselect from '@vueform/multiselect/';


var a = ['','one ','two ','three ','four ', 'five ','six ','seven ','eight ','nine ','ten ','eleven ','twelve ','thirteen ','fourteen ','fifteen ','sixteen ','seventeen ','eighteen ','nineteen '];
var b = ['', '', 'twenty','thirty','forty','fifty', 'sixty','seventy','eighty','ninety'];

app.config.globalProperties.inWords = function(num) {
    if ((num = num.toString()).length > 9) return 'overflow';
    let n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return; var str = '';
    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
    str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'only ' : '';
    
    if(str.includes('only')) {
      return str;
    }else{
      return str + ' only';
    }
} 

// Number Formatter 
// app.config.globalProperties.formatNumberWithDecimals = function(value, decVal = '') {
//   let amount = value;

//   if (value === null || value === undefined || value === '') {
//     amount = 0;
//   }

//   const decimalPlaces = decVal === '' ? 0 : parseInt(decVal);

//   return new Intl.NumberFormat('en-US', {
//     minimumFractionDigits: decimalPlaces,
//     maximumFractionDigits: decimalPlaces
//   }).format(parseFloat(amount));

// };
app.config.globalProperties.formatNumberWithDecimals = function(value, decVal = '') {
  let amount = value;

  if (value === null || value === undefined || value === '') {
    amount = 0;
  }

  const decimalPlaces = decVal === '' ? 0 : parseInt(decVal);
  const isNegative = parseFloat(amount) < 0;

  const absoluteAmount = Math.abs(parseFloat(amount));

  let formatted = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces
  }).format(absoluteAmount);

  if (isNegative) {
    formatted = `(${formatted})`;
  }

  return formatted;
};



app.config.globalProperties.headers = {headers: {
                      'Authorization' : store.getters.token ? `Bearer ${store.getters.token}` : "",
                      'Content-Type': 'multipart/form-data' 
                    }};
app.config.globalProperties.headerjson = {headers: {
                      'Authorization' : store.getters.token ? `Bearer ${store.getters.token}` : "",
                      'Content-Type': 'application/json' 
                    }};
app.config.globalProperties.headerparams = {
                      'Authorization' : store.getters.token ? `Bearer ${store.getters.token}` : "",
                      'Content-Type': 'application/json' 
                    };
if((location.host == 'localhost:8180') || (location.host == '127.0.0.1:8180')){ 
	// app.config.globalProperties.apiUrl =  "http://127.0.0.1:8000/api";
	// app.config.globalProperties.baseUrl =  "http://127.0.0.1:8000"; 
	// app.config.globalProperties.baseUrlPrintCSS =  "http://127.0.0.1:8000"; 
	// app.config.globalProperties.sampleFileUrl =  "http://127.0.0.1:8000"; 

  app.config.globalProperties.apiUrl =  "http://127.0.0.1:9001/api";
	app.config.globalProperties.baseUrl =  "http://127.0.0.1:9001"; 
	app.config.globalProperties.baseUrlPrintCSS =  "http://127.0.0.1:9001"; 
	app.config.globalProperties.sampleFileUrl =  "http://127.0.0.1:9001"; 
}
else {
	app.config.globalProperties.apiUrl = "https://"+location.host+"/backend/api";
	app.config.globalProperties.baseUrl = "https://"+location.host+"/backend";
	app.config.globalProperties.baseUrlPrintCSS = "https://"+location.host+"/backend/public";
	app.config.globalProperties.sampleFileUrl = "https://"+location.host+"/backend/public";
}  

app.config.globalProperties.$createElement = '';
app.config.globalProperties.reRenderRoute = 0;
app.config.globalProperties.siteLogo =  "/assets/images/logo.png";  
app.config.globalProperties.address =  "Patdol, Panditsar, Naria, Shariatpur";  
app.config.globalProperties.invHeadAddress =  "Patdol, Panditsar, Naria, Shariatpur";  
app.config.globalProperties.invHeadPhone =  "+880 1755 522070";// 01739897087  
app.config.globalProperties.prepareBy =  "Sys Admin";  
app.config.globalProperties.checkedBy =  "";  
app.config.globalProperties.approvedBy =  "";  
  
app.config.globalProperties.retailShopName =  "Abdur Rahim";  
app.config.globalProperties.retailSmallText =  "Health Care Center";  
app.config.globalProperties.retailShopAddress =  "Patdol, Panditsar, Naria, Shariatpur";  

app.config.globalProperties.prescriptionHospitalName =  "Abdur Rahim Health Care Center";  
app.config.globalProperties.prescriptionAddress =  "Patdol, Panditsar, Naria, Shariatpur";  
app.config.globalProperties.prescriptionPhone =  "+880 1755 522070";  
app.config.globalProperties.prescriptionHotLine =  "+880 1755 522070";  
app.config.globalProperties.prescriptionEmail =  "info@armtbd.org";    
app.config.globalProperties.prescriptionWeb =  "www.armtbd.org";

app.config.globalProperties.headOfficeAddressTitle =  "Dhaka Office:";  
app.config.globalProperties.headOfficeAddress =  "Nabosrista Plot#1, A Tejgaon I/A, Dhaka - 1208";  
app.config.globalProperties.headOfficePhone =  "09610-774774";  
app.config.globalProperties.headOfficeEmail =  "info@ssgbd.com";    
app.config.globalProperties.headOfficeWeb =  "www.ssgbd.com";

// for turn off warning
app.config.warnHandler = function (msg, vm, trace) {
  return null
}

// For Base64 Encode
app.config.globalProperties.base64Encode = function (str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
    return String.fromCharCode('0x' + p1);
  }));
}

// For Base64 Decode
app.config.globalProperties.base64Decode = function (str) {
  return decodeURIComponent(atob(str).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
}

app.config.globalProperties.formatDate = function (dateStr, formatType = 'DD/MM/YYYY') {
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  if (formatType === 'DD/MM/YYYY') {
    return `${day}/${month}/${year}`;
  } else if (formatType === 'MM/DD/YYYY') {
    return `${month}/${day}/${year}`;
  } else {
    return dateStr; // Return original string if formatType is unrecognized
  }
}

// Form Appointment time formatter
app.config.globalProperties.formatAppointmentTime = function (timeStr) {
  if (!timeStr) return '';
  const [hour, minute, second] = timeStr.split(':').map(Number);
  const period = hour >= 12 ? 'PM' : 'AM';
  const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
  return `${formattedHour}:${String(minute).padStart(2, '0')} ${period}`;
}

app.use(router)  
app.use(FontAwesomeIcon)  
app.use(notification) 
app.use(jQuery)   
app.use(store)   
app.use(Vue3Transitions)
app.use(Toaster) 
app.use(Toast); 
app.use(VueSweetalert2)  
app.component('Multiselect', VueformMultiselect)   
app.component("Treeselect", Vue3TreeSelect); 
app.component(VueBarcode.name, VueBarcode);
app.use(VueApexCharts); 
app.use(moment); 
app.use(VueHtmlToPaper)
app.mount('#app')